// reports/TenantList.jsx

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { Button, Select, Dropdown } from "antd";
import { Menu, Form, Space, DatePicker } from 'antd';

import { IconButton } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel} from '@fortawesome/free-solid-svg-icons';

import dayjs from "dayjs";

import authAxios from "../components/authAxios";
import DashboardHeader from "../components/DashboardHeader";
import Loading from "../components/Loading";
import StandardReportTable from "./StandardReportTable";
import './Report.css';


// import { authAxios } from "../../utils/axios";

const formatAmount = (value) => {
    if (value == null) return "—";
    return Number(value).toLocaleString("en-KE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const formatDate = (value) =>
    value ? dayjs(value).format("DD-MM-YYYY") : "—";

const TenantList = () => {
    const { RangePicker } = DatePicker;
    const [propertyId, setPropertyId] = useState(null);


    // Fetch properties for the filter dropdown
    const { data: properties = [] } = useQuery({
        queryKey: ["properties-list"],
        queryFn: async () => {
            const res = await authAxios.get("rentals/properties/");
            return res.data;
        },
    });

    const { data, isLoading } = useQuery({
        queryKey: ["tenant-list", propertyId],
        queryFn: async () => {
            const params = new URLSearchParams();
            if (propertyId) params.set("property_id", propertyId);
            const res = await authAxios.get(`/rentals/tenant-list-report/?${params}`);
            return res.data;
        },
    });

    // const filterOverlay = (
    //     <div
    //         style={{
    //             padding: 16,
    //             background: "#fff",
    //             borderRadius: 8,
    //             boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    //             minWidth: 240,
    //         }}
    //     >
    //         <div style={{ marginBottom: 8, fontSize: 12, color: "#888" }}>
    //             PROPERTY
    //         </div>
    //         <Select
    //             allowClear
    //             placeholder="All properties"
    //             style={{ width: "100%" }}
    //             value={propertyId}
    //             onChange={setPropertyId}
    //             options={properties.map((p) => ({
    //                 value: p.id,
    //                 label: p.name,
    //             }))}
    //         />
    //     </div>
    // );
    const menu = (
        <Menu>
            <form className="filter-form">
                <Space direction="vertical">
                    <RangePicker 
                        style={{margin:'10px'}}  
                        // onChange={onChange} 
                        placement="bottomRight" 
                    /> 
                </Space>
            </form>
        </Menu>
    );

    if (isLoading) return <Loading loading />;

    const { rows = [], total_tenants } = data ?? {};

    return (
        <div className="dashboard-main standard-report">
            <section className="dashboard-content">
                <div className="dashboard-content-header-nav">
                    <DashboardHeader
                        dashboardTitle="Tenant List"
                        dashboardPreTitle="Reports"
                    />
                    {/* <div className="dashboard-content-header-nav-icons">
                        <Dropdown
                            dropdownRender={() => filterOverlay}
                            trigger={["click"]}
                            placement="bottomRight"
                        >
                            <Button
                                className="menu-button-filter"
                                variant="outlined"
                                startIcon={<TuneIcon />}
                            >
                                Filter
                            </Button>
                        </Dropdown>
                    </div> */}
                    <div className="dashboard-content-header-nav-icons">
                        {/* <IconButton onClick={downloadXLS}> */}
                        <IconButton disabled>
                            <FontAwesomeIcon className="menu-icon" icon={faFileExcel} />
                        </IconButton>
                        <Dropdown disabled overlay={menu} trigger={['click']} placement="bottomRight" arrow>
                            <Button className="menu-button-filter" variant="outlined" startIcon={<TuneIcon />}>
                                Filter
                            </Button>
                        </Dropdown>
                    </div>
                </div>

                {/* <table>
                    <thead>
                        <tr>
                            <th>CODE</th>
                            <th>TENANT</th>
                            <th>TELEPHONE</th>
                            <th>PROPERTY</th>
                            <th>UNIT</th>
                            <th>LEASE START</th>
                            <th>RENEWAL DATE</th>
                            <th className="cell-align-right">PAYABLE AMOUNT</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.id}>
                                <td>{row.tenant_code}</td>
                                <td>{row.name}</td>
                                <td>{row.telephone}</td>
                                <td>{row.property_name}</td>
                                <td>{row.unit_reference}</td>
                                <td>{formatDate(row.lease_start_date)}</td>
                                <td>{formatDate(row.lease_end_date)}</td>
                                <td className="cell-align-right">{formatAmount(row.payable_amount)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={8} className="cell-align-right">
                                {formatAmount(data?.totals.payable_amount)}
                            </td>
                        </tr>
                    </tfoot>
                </table> */}
                <StandardReportTable
                    columns={data?.columns || []}
                    rows={data?.rows || []}
                    totals={data?.totals || {}}
                />
            </section>
        </div>
    );
};

export default TenantList;